export default "__VITE_ASSET__BsOXVVca__"